export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时热点追踪',
    desc: '7×24小时不间断更新，娱乐圈、网红圈最新动态第一时间推送，不错过任何一个大瓜。',
  },
  {
    icon: 'ri-spy-line',
    title: '独家一手爆料',
    desc: '深入挖掘圈内猛料，幕后故事、未公开细节，让你比别人先一步了解真相。',
  },
  {
    icon: 'ri-stack-line',
    title: '多平台聚合',
    desc: '微博、抖音、小红书、B站等主流平台热点一网打尽，一个入口看遍全网热议。',
  },
  {
    icon: 'ri-live-line',
    title: '视频吃瓜专区',
    desc: '精选今日吃瓜视频，名场面回放、翻车合集、精彩剪辑，视觉吃瓜更过瘾。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '理性吃瓜社区',
    desc: '拒绝网络暴力，倡导客观讨论。和万千瓜友一起文明吃瓜，分享你的观点与态度。',
  },
];

export const about = {
  title: '关于在线吃瓜',
  content:
    '在线吃瓜是51在线吃瓜今日吃瓜入口旗下的综合性娱乐八卦聚合平台，致力于为广大瓜友提供最新鲜、最劲爆的今日热点内容。我们聚合全网权威信源和民间爆料渠道，覆盖明星、综艺、选秀、网红、热播剧等热门领域，每日更新吃瓜内容，以专业视角梳理事件脉络，让每一位用户都能快速获取今日吃瓜最新爆料。无论是热搜话题深度解读，还是圈内独家猛料，在线吃瓜今日热点板块为你持续输出高质量内容。同时，今日吃瓜视频专区汇集全网最火吃瓜名场面，图文视频多维呈现，满足不同用户的浏览习惯。坚持"吃瓜不造谣、围观不网暴"的理念，打造健康积极的吃瓜文化，让每日吃瓜成为一种娱乐生活方式。',
};

export const contact = {
  title: '投稿爆料',
  desc: '你有独家猛料？发现热点线索？欢迎通过以下方式联系我们。在线吃瓜团队承诺保护爆料人隐私，每一条投稿内容都会认真核实后发布，让你的声音被更多人听见。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tougao@onlinechigua.com' },
    { icon: 'ri-wechat-line', label: '微信客服', value: 'chigua51kefu' },
    { icon: 'ri-at-line', label: '微博私信', value: '@在线吃瓜官方' },
  ],
};

export const topics = [
  { tag: '娱乐圈大瓜', hot: true, count: '128万讨论' },
  { tag: '综艺名场面', hot: true, count: '96万讨论' },
  { tag: '网红翻车现场', hot: true, count: '85万讨论' },
  { tag: '明星恋情曝光', hot: true, count: '203万讨论' },
  { tag: '热播剧吐槽', hot: false, count: '67万讨论' },
  { tag: '热搜第一', hot: false, count: '312万讨论' },
  { tag: '粉丝互撕', hot: false, count: '54万讨论' },
  { tag: '直播名场面', hot: false, count: '73万讨论' },
  { tag: '塌房预警', hot: true, count: '156万讨论' },
  { tag: '选秀内幕', hot: false, count: '41万讨论' },
  { tag: '吃瓜前线', hot: true, count: '189万讨论' },
];

export const updates = [
  {
    date: '2026-07-30',
    time: '15:42',
    title: '某顶流男星被拍到深夜密会神秘女子，工作室尚未回应',
    tag: '最新爆料',
    tagColor: 'primary',
  },
  {
    date: '2026-07-30',
    time: '12:18',
    title: '热门综艺节目录制现场突发意外，导演组紧急暂停录制',
    tag: '现场直击',
    tagColor: 'accent',
  },
  {
    date: '2026-07-30',
    time: '09:05',
    title: '知名网红直播带货翻车，商品质量问题引发粉丝集体维权',
    tag: '翻车现场',
    tagColor: 'primary',
  },
  {
    date: '2026-07-29',
    time: '22:30',
    title: '某选秀节目选手被曝黑历史，节目组连夜发布声明',
    tag: '深度扒皮',
    tagColor: 'secondary',
  },
  {
    date: '2026-07-29',
    time: '18:15',
    title: '热播剧大结局引发全网热议，编剧在线回复观众质疑',
    tag: '今日热点',
    tagColor: 'accent',
  },
  {
    date: '2026-07-29',
    time: '14:00',
    title: '娱乐圈又一对明星官宣分手，工作室发联合声明证实',
    tag: '恋情动态',
    tagColor: 'primary',
  },
  {
    date: '2026-07-28',
    time: '20:48',
    title: '某知名品牌代言人突然解约，背后原因引发多种猜测',
    tag: '商业八卦',
    tagColor: 'secondary',
  },
];

export const faq = [
  {
    q: '在线吃瓜和其他八卦平台有什么不同？',
    a: '我们坚持"吃瓜不造谣"的原则，所有爆料内容经过多方信源交叉核实后再发布。同时提供图文、视频、话题讨论等多元内容形态，让你一站式获取今日吃瓜最新爆料和今日热点。',
  },
  {
    q: '如何第一时间收到最新爆料通知？',
    a: '你可以将51在线吃瓜今日吃瓜入口添加到浏览器收藏夹，或关注我们的微博、微信公众号"在线吃瓜"，每日推送今日吃瓜视频和热点内容，精彩内容不错过。',
  },
  {
    q: '我可以投稿爆料吗？如何保护隐私？',
    a: '当然可以！我们欢迎每一位瓜友提供线索。投稿时可以使用匿名邮箱，我们会对爆料人身份信息严格保密，绝不外泄。请通过页面中的投稿入口联系我们。',
  },
  {
    q: '今日吃瓜视频在哪能看到？',
    a: '在线吃瓜今日热点页面设有专门的视频专区，汇集全网热门吃瓜视频内容，包括名场面回放、翻车集锦、精彩剪辑等，不需要跳转到其他平台就能观看。',
  },
  {
    q: '如何参与话题讨论和互动？',
    a: '在每篇爆料和热点文章下方都可以发表评论，和其他瓜友一起交流观点。我们倡导理性讨论，拒绝人身攻击和网络暴力，共同维护良好的吃瓜氛围。',
  },
];

export const indexItems = [
  {
    icon: 'ri-star-line',
    title: '明星八卦精选',
    desc: '最新明星动态、恋情曝光、活动路透，第一手明星资讯尽在这里。',
    count: '今日更新 23 篇',
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20stylized%20entertainment%20celebrity%20gossip%20collage%20with%20magazine%20aesthetic%2C%20soft%20gradient%20background%20in%20warm%20beige%20and%20rose%20tones%2C%20artistic%20abstract%20composition%20with%20glamorous%20vibe%2C%20editorial%20design%2C%20no%20text%2C%20clean%20minimal%20style&width=400&height=300&seq=index-1&orientation=landscape',
  },
  {
    icon: 'ri-tv-line',
    title: '综艺名场面',
    desc: '热门综艺高能片段、幕后花絮、选手争议事件全程跟踪。',
    count: '今日更新 17 篇',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20variety%20show%20stage%20abstract%20art%20with%20warm%20spotlight%20effects%2C%20soft%20cream%20and%20gold%20color%20palette%2C%20artistic%20rendering%20of%20stage%20lights%20and%20silhouettes%2C%20editorial%20magazine%20style%2C%20elegant%20composition%2C%20no%20text&width=400&height=300&seq=index-2&orientation=landscape',
  },
  {
    icon: 'ri-user-smile-line',
    title: '网红观察室',
    desc: '网红圈最新动态、直播翻车、人设崩塌，吃瓜必备情报站。',
    count: '今日更新 31 篇',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20influencer%20aesthetic%20in%20warm%20coral%20and%20cream%20tones%2C%20stylized%20smartphone%20and%20camera%20motifs%2C%20soft%20gradient%20background%2C%20editorial%20design%20with%20modern%20minimal%20feel%2C%20no%20text%2C%20artistic%20composition&width=400&height=300&seq=index-3&orientation=landscape',
  },
  {
    icon: 'ri-film-line',
    title: '热播剧吃瓜',
    desc: '剧情分析、演员八卦、翻拍争议，追剧和吃瓜两不误。',
    count: '今日更新 19 篇',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20film%20and%20drama%20abstract%20collage%20with%20warm%20amber%20and%20rose%20tones%2C%20stylized%20film%20reel%20and%20clapperboard%20elements%2C%20soft%20cream%20background%2C%20editorial%20magazine%20aesthetic%2C%20clean%20elegant%20style%2C%20no%20text&width=400&height=300&seq=index-4&orientation=landscape',
  },
  {
    icon: 'ri-music-2-line',
    title: '选秀全追踪',
    desc: '选秀节目全程跟进，选手背景深扒、排名变动实时更新。',
    count: '今日更新 15 篇',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20talent%20show%20competition%20abstract%20art%20with%20warm%20gradient%20background%2C%20soft%20golden%20spotlight%20effects%2C%20elegant%20minimal%20illustration%20style%2C%20cream%20and%20coral%20color%20palette%2C%20editorial%20design%2C%20no%20text&width=400&height=300&seq=index-5&orientation=landscape',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    title: '代言风云榜',
    desc: '品牌代言人更迭、商业合作内幕，奢侈品到快消全覆盖。',
    count: '今日更新 12 篇',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20luxury%20brand%20endorsement%20aesthetic%20with%20warm%20beige%20and%20gold%20tones%2C%20stylized%20fashion%20elements%2C%20soft%20gradient%20background%2C%20editorial%20magazine%20layout%20feel%2C%20clean%20minimal%20composition%2C%20no%20text&width=400&height=300&seq=index-6&orientation=landscape',
  },
  {
    icon: 'ri-temp-hot-line',
    title: '热搜解码器',
    desc: '每日热搜话题深度解读，从飙升榜到娱乐榜，热点背后故事。',
    count: '今日更新 28 篇',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20trending%20topic%20heatmap%20abstract%20art%20with%20warm%20coral%20and%20peach%20gradient%2C%20soft%20circular%20data%20visualization%20motifs%2C%20cream%20background%2C%20editorial%20design%20style%2C%20modern%20clean%20aesthetic%2C%20no%20text&width=400&height=300&seq=index-7&orientation=landscape',
  },
  {
    icon: 'ri-global-line',
    title: '国际八卦站',
    desc: '海外娱乐圈动态一手掌握，好莱坞、K-POP、日娱热门资讯。',
    count: '今日更新 9 篇',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20global%20entertainment%20news%20collage%20with%20warm%20terracotta%20and%20cream%20tones%2C%20stylized%20world%20map%20elements%2C%20soft%20gradient%20background%2C%20editorial%20magazine%20aesthetic%2C%20clean%20minimal%20style%2C%20no%20text&width=400&height=300&seq=index-8&orientation=landscape',
  },
];

export const cards = [
  {
    title: '某知名女星疑似婚变，社交平台清空与丈夫所有合照',
    tag: '娱乐圈大瓜',
    desc: '近日有网友发现，某一线女星的社交账号突然清空了与丈夫的全部合影，引发婚变猜测。知情人士透露两人已分居数月...',
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20stylized%20celebrity%20drama%20abstract%20art%20with%20split%20composition%20in%20soft%20rose%20and%20cream%2C%20emotional%20distance%20motif%2C%20editorial%20magazine%20aesthetic%2C%20elegant%20minimal%20style%2C%20no%20text%2C%20clean%20design&width=600&height=400&seq=card-1&orientation=landscape',
  },
  {
    title: '综艺录制现场道具倒塌，工作人员受伤引发安全争议',
    tag: '综艺名场面',
    desc: '某大型综艺节目录制过程中突发舞台道具倒塌事故，导致一名工作人员受伤送医。网友纷纷质疑节目组安全措施是否到位...',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20set%20design%20with%20warm%20amber%20dramatic%20lighting%2C%20stylized%20stage%20elements%20in%20toppled%20composition%2C%20soft%20cream%20and%20gold%20background%2C%20editorial%20photography%20style%2C%20clean%20minimal%2C%20no%20text&width=600&height=400&seq=card-2&orientation=landscape',
  },
  {
    title: '千万粉丝网红被曝虚假宣传，消费者协会已介入调查',
    tag: '网红翻车',
    desc: '拥有千万粉丝的带货主播近日陷入虚假宣传风波，所售商品与宣传严重不符。目前消费者协会已正式介入调查此事...',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20social%20media%20controversy%20abstract%20art%20with%20warm%20coral%20and%20beige%20tones%2C%20broken%20trust%20motifs%2C%20soft%20gradient%20background%2C%20editorial%20magazine%20style%2C%20clean%20modern%20composition%2C%20no%20text&width=600&height=400&seq=card-3&orientation=landscape',
  },
  {
    title: '顶流小生新剧开播收视率暴跌，演技遭网友群嘲',
    tag: '热播剧吐槽',
    desc: '某顶流男演员主演的新剧开播后收视率持续走低，首播收视率较预期腰斩。网友对其表演方式展开了热烈讨论...',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20drama%20criticism%20art%20with%20warm%20terracotta%20and%20cream%20gradient%2C%20stylized%20screen%20and%20audience%20motifs%2C%20soft%20editorial%20design%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=600&height=400&seq=card-4&orientation=landscape',
  },
  {
    title: '选秀节目选手背景造假被揭穿，节目组宣布取消其参赛资格',
    tag: '选秀内幕',
    desc: '某热门选秀节目人气选手被曝学历和履历造假，经过节目组调查核实后，正式宣布取消其参赛资格，其票数全部清零...',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20talent%20competition%20disqualification%20abstract%20art%20with%20warm%20rose%20and%20beige%20tones%2C%20falling%20elements%20motif%2C%20soft%20gradient%20background%2C%20editorial%20magazine%20style%2C%20clean%20composition%2C%20no%20text&width=600&height=400&seq=card-5&orientation=landscape',
  },
];

export const mediaItems = [
  {
    title: '本周最劲爆娱乐圈大瓜盘点',
    duration: '15:28',
    views: '238万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20video%20thumbnail%20abstract%20art%20with%20entertainment%20news%20collage%20style%2C%20soft%20coral%20and%20cream%20gradient%20background%2C%20play%20button%20motif%2C%20editorial%20magazine%20design%2C%20clean%20modern%20aesthetic%2C%20no%20text&width=600&height=340&seq=media-1&orientation=landscape',
  },
  {
    title: '明星恋情曝光全回顾：那些年我们吃过的瓜',
    duration: '22:10',
    views: '186万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20celebrity%20romance%20gossip%20abstract%20art%20with%20warm%20rose%20and%20gold%20tones%2C%20heart%20silhouette%20motif%2C%20soft%20gradient%20background%2C%20editorial%20design%20style%2C%20clean%20minimal%2C%20no%20text&width=600&height=340&seq=media-2&orientation=landscape',
  },
  {
    title: '网红翻车名场面合集：笑到停不下来',
    duration: '08:45',
    views: '321万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20funny%20moments%20collage%20art%20with%20warm%20amber%20and%20peach%20gradient%2C%20playful%20composition%20with%20soft%20shapes%2C%20cream%20background%2C%20editorial%20magazine%20aesthetic%2C%20clean%20modern%20style%2C%20no%20text&width=600&height=340&seq=media-3&orientation=landscape',
  },
];

export const carouselItems = [
  {
    title: '娱乐圈年度十大未解之谜',
    desc: '那些轰动一时却至今没有真相的大瓜，一起来回顾这些悬案背后的蛛丝马迹。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20mystery%20detective%20abstract%20art%20with%20warm%20terracotta%20and%20cream%20gradient%2C%20magnifying%20glass%20and%20question%20mark%20silhouettes%2C%20editorial%20magazine%20design%2C%20elegant%20minimal%20style%2C%20no%20text%2C%20soft%20dramatic%20lighting&width=800&height=450&seq=carousel-1&orientation=landscape',
  },
  {
    title: '从素人到顶流：新生代明星的爆红之路',
    desc: '盘点近三年快速崛起的娱乐圈新势力，他们凭什么在激烈的竞争中脱颖而出。',
    tag: '人物聚焦',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20rising%20star%20ascension%20art%20with%20warm%20golden%20and%20rose%20gradient%2C%20staircase%20and%20spotlight%20motifs%2C%20cream%20background%2C%20editorial%20magazine%20aesthetic%2C%20clean%20elegant%20composition%2C%20no%20text&width=800&height=450&seq=carousel-2&orientation=landscape',
  },
  {
    title: '综艺节目二十年：从草根选秀到全明星竞技',
    desc: '回顾中国综艺节目前二十年的演变历程，探讨观众口味的变化与行业未来的走向。',
    tag: '行业观察',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20TV%20history%20timeline%20abstract%20art%20with%20warm%20coral%20and%20cream%20gradient%2C%20retro%20TV%20elements%2C%20soft%20editorial%20design%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20elegant%20aesthetic&width=800&height=450&seq=carousel-3&orientation=landscape',
  },
  {
    title: '品牌代言背后的商业逻辑：为什么是他们？',
    desc: '深度解析品牌选择代言人的考量标准，从数据到人设，揭秘代言费背后的商业故事。',
    tag: '商业揭秘',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20brand%20endorsement%20business%20art%20with%20warm%20amber%20and%20beige%20gradient%2C%20handshake%20and%20contract%20silhouettes%2C%20editorial%20magazine%20style%2C%20clean%20elegant%20composition%2C%20no%20text&width=800&height=450&seq=carousel-4&orientation=landscape',
  },
  {
    title: '"塌房"经济学：明星翻车对行业的影响有多大？',
    desc: '从品牌损失到粉丝流失，一文看懂明星负面事件背后的连锁效应和市场影响。',
    tag: '数据报告',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20economic%20impact%20abstract%20art%20with%20warm%20rose%20and%20cream%20gradient%2C%20falling%20graph%20and%20cracks%20motifs%2C%20editorial%20design%20style%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=450&seq=carousel-5&orientation=landscape',
  },
];

export const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子', hot: '🔥 289万热度' },
  { rank: 2, title: '千万粉丝网红虚假宣传被查', hot: '🔥 256万热度' },
  { rank: 3, title: '选秀节目选手背景造假被退赛', hot: '🔥 234万热度' },
  { rank: 4, title: '热播剧大结局引发全网吐槽', hot: '🔥 198万热度' },
  { rank: 5, title: '知名女星清空社交平台合照引婚变猜测', hot: '🔥 175万热度' },
  { rank: 6, title: '综艺节目录制现场事故致人受伤', hot: '🔥 152万热度' },
];

export const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20portrait%20in%20warm%20cream%20and%20coral%20tones%2C%20abstract%20face%20silhouette%2C%20soft%20gradient%2C%20editorial%20design%2C%20clean%20simple%20style%2C%20no%20text&width=80&height=80&seq=avatar-1&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个瓜我吃定了！每天打开在线吃瓜都有新惊喜，更新速度真的快，比我自己刷微博效率高多了。',
    likes: 1283,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20portrait%20in%20warm%20amber%20and%20beige%20tones%2C%20abstract%20face%20silhouette%2C%20soft%20gradient%2C%20editorial%20design%2C%20clean%20simple%20style%2C%20no%20text&width=80&height=80&seq=avatar-2&orientation=squarish',
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '理性吃瓜最重要，这个平台的内容相对客观，不会带节奏。希望继续保持，不要像某些号一样为了流量乱写。',
    likes: 967,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20portrait%20in%20warm%20rose%20and%20cream%20tones%2C%20abstract%20face%20silhouette%2C%20soft%20gradient%2C%20editorial%20design%2C%20clean%20simple%20style%2C%20no%20text&width=80&height=80&seq=avatar-3&orientation=squarish',
    name: '每天都要开心鸭',
    time: '8小时前',
    content: '吃瓜是我每天的快乐源泉哈哈！视频专区特别好，吃饭时候看简直下饭神器。支持在线吃瓜越做越好！',
    likes: 2156,
  },
];

export const appInfo = {
  title: '随时随地 吃瓜不停',
  desc: '关注在线吃瓜微信公众号和小程序，第一时间获取今日吃瓜最新爆料和今日热点推送。手机端浏览体验优化，随时随地畅快吃瓜。',
  features: ['每日推送最新爆料', '视频专区随心看', '话题讨论实时参与', '收藏功能不错过'],
  qrImg: 'https://readdy.ai/api/search-image?query=Stylized%20minimal%20QR%20code%20design%20in%20warm%20cream%20and%20coral%20tones%2C%20abstract%20square%20pattern%2C%20soft%20gradient%20background%2C%20clean%20modern%20style%2C%20editorial%20design%2C%20no%20text&width=300&height=300&seq=qr-app&orientation=squarish',
};